/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_AttributeDetailsGet } from '../models/Model_AttributeDetailsGet';
import type { Model_AttributeIdentityGet } from '../models/Model_AttributeIdentityGet';
import type { Model_ConfigurationBulkPut } from '../models/Model_ConfigurationBulkPut';
import type { Model_ConfigurationGet } from '../models/Model_ConfigurationGet';
import type { Model_ConfigurationQueryFilterGet } from '../models/Model_ConfigurationQueryFilterGet';
import type { Model_ConfigurationQueryFilterPost } from '../models/Model_ConfigurationQueryFilterPost';
import type { Model_ConfigurationsGet } from '../models/Model_ConfigurationsGet';
import type { Model_ConfiguratorOrderOut } from '../models/Model_ConfiguratorOrderOut';
import type { Model_ConfiguratorProductGet } from '../models/Model_ConfiguratorProductGet';
import type { Model_CustomerPortalPossibleCustomerGet } from '../models/Model_CustomerPortalPossibleCustomerGet';
import type { Model_ProjectExtendedGet } from '../models/Model_ProjectExtendedGet';
import type { Model_ProjectGet } from '../models/Model_ProjectGet';
import type { Model_ProjectLineItemAttributePut } from '../models/Model_ProjectLineItemAttributePut';
import type { Model_ProjectLineItemCreatePut } from '../models/Model_ProjectLineItemCreatePut';
import type { Model_ProjectLineItemExtendedGet } from '../models/Model_ProjectLineItemExtendedGet';
import type { Model_ProjectLineItemPut } from '../models/Model_ProjectLineItemPut';
import type { Model_ProjectLineItemsBulkPut } from '../models/Model_ProjectLineItemsBulkPut';
import type { Model_ProjectProductsFilterPut } from '../models/Model_ProjectProductsFilterPut';
import type { Model_ProjectPut } from '../models/Model_ProjectPut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConfiguratorService {
    /**
     * @param identityId
     * @param customerId
     * @param correlationId
     * @returns Model_ProjectGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjects(
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_ProjectGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projects',
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @returns Model_ProjectExtendedGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjects1(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ProjectExtendedGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projects/{projectId}',
            path: {
                'projectId': projectId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param requestBody
     * @returns Model_ProjectExtendedGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorProjects(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectPut>,
    ): CancelablePromise<Model_ProjectExtendedGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/projects/{projectId}',
            path: {
                'projectId': projectId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiV1ConfiguratorProjects(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/configurator/projects/{projectId}',
            path: {
                'projectId': projectId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param identityId
     * @param customerId
     * @param correlationId
     * @returns Model_AttributeDetailsGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjectsAttributes(
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_AttributeDetailsGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projects/attributes',
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param requestBody
     * @returns Model_ConfiguratorProductGet Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorProjectsGetProducts(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectProductsFilterPut>,
    ): CancelablePromise<Array<Model_ConfiguratorProductGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/projects/getProducts/{projectId}',
            path: {
                'projectId': projectId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectLineItemId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @returns Model_ProjectLineItemExtendedGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjectLineItems(
        projectLineItemId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ProjectLineItemExtendedGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projectLineItems/{projectLineItemId}',
            path: {
                'projectLineItemId': projectLineItemId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectLineItemId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param requestBody
     * @returns Model_ProjectLineItemExtendedGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorProjectLineItems(
        projectLineItemId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectLineItemPut>,
    ): CancelablePromise<Model_ProjectLineItemExtendedGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/projectLineItems/{projectLineItemId}',
            path: {
                'projectLineItemId': projectLineItemId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectLineItemId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param requestBody
     * @returns Model_ProjectLineItemExtendedGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorProjectLineItemsCreate(
        projectLineItemId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectLineItemCreatePut>,
    ): CancelablePromise<Model_ProjectLineItemExtendedGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/projectLineItems/create/{projectLineItemId}',
            path: {
                'projectLineItemId': projectLineItemId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectLineItemId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param requestBody
     * @returns Model_ProjectLineItemExtendedGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorProjectLineItemsAttributes(
        projectLineItemId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectLineItemAttributePut>,
    ): CancelablePromise<Model_ProjectLineItemExtendedGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/projectLineItems/attributes{projectLineItemId}',
            path: {
                'projectLineItemId': projectLineItemId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorProjectLineItemsDelete(
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectLineItemsBulkPut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/projectLineItems/delete',
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param identityId
     * @param customerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorConfigurationDelete(
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ConfigurationBulkPut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/configuration/delete',
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param identityId
     * @param customerId
     * @param correlationId
     * @param blankValues
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorProjectLineItemsCopy(
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
        blankValues?: ConvertDatesToStrings<boolean>,
        requestBody?: ConvertDatesToStrings<Model_ProjectLineItemsBulkPut>,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/projectLineItems/copy',
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
                'blankValues': blankValues,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectLineItemId
     * @param parentLineItemId
     * @param identityId
     * @param customerId
     * @param correlationId
     * @returns Model_AttributeIdentityGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorProjectLineItemsMove(
        projectLineItemId: ConvertDatesToStrings<string>,
        parentLineItemId?: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        correlationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_AttributeIdentityGet>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/projectLineItems/move/{projectLineItemId}',
            path: {
                'projectLineItemId': projectLineItemId,
            },
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'parentLineItemId': parentLineItemId,
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param correlationId
     * @param publicJksPlusCustomerLoginOverrideId
     * @returns Model_CustomerPortalPossibleCustomerGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorCustomerList(
        correlationId?: ConvertDatesToStrings<string>,
        publicJksPlusCustomerLoginOverrideId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_CustomerPortalPossibleCustomerGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/customerList',
            headers: {
                'correlationId': correlationId,
            },
            query: {
                'publicJKSPlusCustomerLoginOverrideId': publicJksPlusCustomerLoginOverrideId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @returns Model_ConfiguratorOrderOut Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorGenerateOrder(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfiguratorOrderOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/generateOrder/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorGenerateOrderFile(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/generateOrderFile/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param configurationId
     * @param identityId
     * @param customerId
     * @returns Model_ConfiguratorOrderOut Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorGenerateConfigurationOrder(
        projectId: ConvertDatesToStrings<string>,
        configurationId?: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfiguratorOrderOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/generateConfigurationOrder/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'configurationId': configurationId,
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @param requestBody
     * @returns Model_ConfigurationsGet Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorConfigurations(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ConfigurationQueryFilterPost>,
    ): CancelablePromise<Model_ConfigurationsGet> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/configurations/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param configurationId
     * @param identityId
     * @param customerId
     * @returns Model_ConfigurationGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorConfiguration(
        configurationId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfigurationGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/configuration/{configurationId}',
            path: {
                'configurationId': configurationId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param projectId
     * @param identityId
     * @param customerId
     * @returns Model_ConfigurationQueryFilterGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorConfigurationsFilter(
        projectId: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfigurationQueryFilterGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/configurations/filter/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
}
